import React from 'react';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy">
            <div className="pp-container">
                <h1>Privacy Policy</h1>
                <br></br>
                <h2>Collection Of Personally-identifiable Information</h2>
                <p>Marlin Spring Developments is committed to protecting the privacy of the personally-identifiable information that we collect from you. The scope of our commitment is detailed in this privacy policy. By submitting information to us, you agree to our use of such information as described herein.</p>
                <h2>Use of Personally-identifiable Information</h2>
                <p>Marlin Spring Developments uses your personally-identifiable information to fulfill your requests for information. Marlin Spring Developments uses personally-identifiable information collected from cookies and IP addresses as described below. Websites are not intentionally designed for or directed at persons 18 years of age or younger, and MARLIN SPRING DEVELOPMENTS will not intentionally collect or maintain information about anyone under the age of 18.</p>



<h2>Use of Cookies</h2>



<p>Websites uses cookies to identify you and your interests and to track your usage of this website. Cookies are small text files stored on your computer that assist us in determining which browser you are using and where you have been on a particular website in order to use some of the features of the website. Cookies also let us know whether you have registered with MARLIN SPRING DEVELOPMENTS and also enable us to relate your current usage of a website to prior usage of the website.</p>



<h2>No Disclosure Of Personally-identifiable Information to Third Parties</h2>



<p>Marlin Spring Developments shall not intentionally disclose (and will take commercially reasonable steps to prevent the accidental disclosure of) your personally-identifiable information to third parties (other than independent real estate brokers authorized by Marlin Spring Developments with respect to a project(s) you have requested information on) without your permission, subject to the following exceptions:</p>



<ol><li>Marlin Spring Developments may disclose your personally-identifiable information to third parties as required or permitted by applicable laws, rules or regulations;</li><br></br><li>Marlin Spring Developments may disclose your contact information in response to inquiries by bona-fide rights owners in connection with allegations of infringements of copyright or other proprietary rights arising from information you have submitted on this website or otherwise provided to Marlin Spring Developments ; and</li><br></br><li>if Marlin Spring Developments (and/or one or more of its affiliates) merges with or sells all or substantially all of its assets to a third party, information collected about you on Websites may be disclosed to such third party.</li><br></br><li>No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data consent: this information will not be shared with any third parties.</li></ol>


<br></br>
<h2>Security</h2>



<p>Marlin Spring Developments has implemented generally accepted standards of technology and operation security in order to protect personally-identifiable information from loss, misuse, alteration or destruction. Only authorized Marlin Spring Developments personnel are provided access to personally-identifiable information, and such employees are required to treat this information as confidential. Notwithstanding these precautions, we cannot guarantee that unauthorized persons will not obtain access to your personally-identifiable information.</p>



<h2>Consent</h2>



<p>By using a Website or filling out a registration form at a sales office, you consent to the collection, use and storage of your information by Marlin Spring Developments in the manner described in this privacy policy. Marlin Spring Developments reserves the right to make changes to this privacy policy from time to time. When using this website, you should review the current Terms of Use and privacy policy to determine if they have been amended since your last visit.</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
